export default __webpack_public_path__ + "static/media/PBE.6c235b5b.png";